import {Injectable, NgZone} from '@angular/core';
import {fromEvent, Observable} from "rxjs";
import {
  ConnectionLostModalComponent
} from "../components/shared/modals/connection-lost-modal/connection-lost-modal.component";
import {MatDialog, MatDialogRef, MatDialogState} from "@angular/material/dialog";

@Injectable({
  providedIn: 'root'
})
export class ConnectionService {
  onlineStatus: Observable<Event>;
  offlineStatus: Observable<Event>;
  modalRef: MatDialogRef<any>;
  constructor(public Dialog: MatDialog, private ngZone: NgZone) {
    this.onlineStatus = fromEvent(window, 'online');
    this.offlineStatus = fromEvent(window, 'offline');
    this.watchConnectionStatus();
  }

  watchConnectionStatus(){
    this.offlineStatus.subscribe(e => {
      this.showNoInternetWarning();
    })
    this.onlineStatus.subscribe(e => {
      if(this.modalRef && this.modalRef.getState() === MatDialogState.OPEN){
        this.ngZone.run(() =>{
          this.modalRef.close();
        })
      }
    })
  }

  showNoInternetWarning(){
    this.modalRef = this.Dialog.open(ConnectionLostModalComponent, {
      disableClose: true,
    })
  }
}
